import React, { useEffect, useRef, useState } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Icon from "./Icons"; // Make sure Icon is imported
import "../styles/About.css";

gsap.registerPlugin(ScrollTrigger);

const About = () => {
  const aboutRef = useRef(null);
  const textRefs = useRef([]);
  const [activeTab, setActiveTab] = useState('professional'); // 'professional' or 'personal'
  
  useEffect(() => {
    gsap.fromTo(".about-title",
      {
        y: 30,
        opacity: 0
      },
      {
        y: 0,
        opacity: 1,
        duration: 0.6,
        ease: "power2.out",
        scrollTrigger: {
          trigger: "#about",
          start: "top 80%",
          toggleActions: "play none none reverse"
        }
      }
    );
    
    gsap.from(textRefs.current, {
      y: 30,
      opacity: 0,
      duration: 0.8,
      stagger: 0.2,
      ease: "power2.out",
      scrollTrigger: {
        trigger: ".about-content",
        start: "top 75%",
        toggleActions: "play none none reverse"
      }
    });
    
    return () => {
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    };
  }, []);
  
  return (
    <section id="about" ref={aboutRef}>
      <div className="section-header">
        <span className="section-title about-title">About Me</span>
      </div>
      
      <div className="about-tabs">
        <button 
          className={`tab-button${activeTab === 'professional' ? ' active' : ''}`}
          onClick={() => setActiveTab('professional')}
        >
          <Icon name="User" className="tab-icon"/> Professional
        </button>
        <button 
          className={`tab-button${activeTab === 'personal' ? ' active' : ''}`}
          onClick={() => setActiveTab('personal')}
        >
          <Icon name="User" className="tab-icon"/> Personal
        </button>
      </div>

      <div className="about-main-content">
        <div className="about-description-wrapper">
          {activeTab === 'professional' && (
        <div className="about-description">
          <p ref={el => textRefs.current[0] = el}>
            Hi, I’m Geetha Sagar Bonthu, an analyst who helps product and marketing teams understand their customers. I’ve built funnel and retention analyses, run A/B tests, and turned campaign, pricing, and engagement data into dashboards teams trust. My work has cut manual reporting by 60% and given teams one source of truth for their metrics.
          </p>

          <p>
            I hold an MS in Business Analytics from the University of Cincinnati and work with SQL, Python, dbt, Snowflake, and Power BI. I’m open to Product Analyst and Marketing Analyst roles.
          </p>
        </div>
          )}

          {activeTab === 'personal' && (
            <div className="about-description personal-content">
              <h3>My Interests & Hobbies</h3>
              <p>Here are some glimpses into my life outside of work:</p>
              <div className="personal-images-gallery">
                <img src="/assets/personal_pic1.JPG" alt="Personal Photo 1" className="personal-gallery-image" />
                <img src="/assets/personal_pic2.jpg" alt="Personal Photo 2" className="personal-gallery-image" />
                <img src="/assets/personal_pic3.jpg" alt="Personal Photo 3" className="personal-gallery-image" />
                <img src="/assets/personal_pic4.JPG" alt="Personal Photo 4" className="personal-gallery-image" />
                <img src="/assets/personal_pic5.jpg" alt="Personal Photo 5" className="personal-gallery-image" />
              </div>
              <p>When I'm not translating data into stories, you'll probably find me out on a <span className="personal-hover-effect" data-emoji="🏍️">bike ride</span>, exploring a new route or <span className="personal-hover-effect" data-emoji="🌅">chasing sunsets</span>.
                I enjoy trying out different sports. <span className="personal-hover-effect" data-emoji="⚽️">Football</span> with friends is a weekend ritual, and I'm always up for learning something new on the field.
                I've got a soft spot for good <span className="personal-hover-effect" data-emoji="☕️">coffee</span> and spontaneous cafe hunts, and nothing beats coming home to my dog, <span className="maxie-hover">Maxie</span>.
                Whether it's a new game, a new trail, or just a great cup of coffee, I'm always chasing the small joys that keep life balanced and fun.</p>
              {/* You can add more text here about your personal life */}
            </div>
          )}
          
        <div className="about-actions" ref={el => textRefs.current[6] = el}>
          <a href="https://docs.google.com/document/d/1eYRKQYROK59bf2DKErCN2x_r7T-iPw_J/edit?usp=sharing&ouid=108798364437461001907&rtpof=true&sd=true" className="resume-button btn-effect" target="_blank" rel="noopener noreferrer">
            View Resume
          </a>
        </div>
        </div>

        {activeTab === 'professional' && (
          <div className="about-image-container">
            <img src="/assets/profile.jpg" alt="Geetha Sagar Bonthu Profile" className="about-profile-image" />
          </div>
        )}
      </div>
    </section>
  );
};

export default About;